import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, watch } from "vue";
import { Close } from '@element-plus/icons-vue';
const __default__ = {
  name: 'commonDrawer'
};
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    showModal: {
      type: Boolean,
      default: true
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    beforeCloseFun: {
      type: Function,
      default: () => {
        return () => {};
      }
    },
    size: {
      type: String,
      default: "450px"
    }
  },
  emits: ["update:modelValue"],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    let visibleHandle = () => {
      emits("update:modelValue", false);
    };
    return (_ctx, _cache) => {
      const _component_el_drawer = _resolveComponent("el-drawer");
      return __props.modelValue ? (_openBlock(), _createBlock(_component_el_drawer, {
        key: 0,
        modal: __props.showModal,
        title: __props.title,
        "custom-class": __props.isDetail ? 'disabledDialog' : '',
        "close-on-click-modal": __props.closeOnClickModal,
        modelValue: __props.modelValue,
        direction: "rtl",
        size: __props.size,
        "before-close": _unref(visibleHandle),
        "ppend-to-body": false
      }, {
        footer: _withCtx(() => [_renderSlot(_ctx.$slots, "footer")]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["modal", "title", "custom-class", "close-on-click-modal", "modelValue", "size", "before-close"])) : _createCommentVNode("", true);
    };
  }
});